<script>
const token = '12345678'
const userSite = 'http://ysw.861718.com/'
export default
{
  userSite, // 用户地址
  token // 用户token身份
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue